import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.5);
  color: white;
  font-size: 1.5em;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  backdrop-filter: blur(5px);

  &:hover {
    background: rgba(255, 255, 255, 0.4);
    transform: scale(1.2) rotate(180deg);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  }
`;

function SecretButton({ onActivate }) {
  return (
    <Button 
      onClick={onActivate}
      title="Secret surprise!"
    >
      ?
    </Button>
  );
}

export default SecretButton;
